import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { getIsDisabledState } from '../../IdentityProofUtils';
import { getTestId, StateConfigContext } from '@airtel/air-design-system';
import { LinkListItemWidget } from '../../../../../link-list-item-widget';
export var IdentityTitleSection = props => {
  var stepDetails = props.stepDetails,
    successStateHeading = props.successStateHeading,
    onStepDetailsListItemPressMetaData = props.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = props.onStepDetailsCtaPressMetaData,
    onUserAction = props.onUserAction,
    handleChangeButtonPress = props.handleChangeButtonPress,
    isExpandedState = props.isExpandedState,
    isDisabledState = props.isDisabledState,
    isSuccessState = props.isSuccessState,
    successAvatarConfig = props.successAvatarConfig,
    subHeading = props.subHeading,
    testID = props.testID,
    variant = props.variant;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  return _jsx(LinkListItemWidget, Object.assign({}, stepDetails, isSuccessState && !isExpandedState && successStateHeading && {
    heading: successStateHeading
  }, {
    roundedCorners: true,
    theme: theme,
    noHoverEffect: true,
    noPressEffect: true,
    onPress: onStepDetailsListItemPressMetaData,
    onUserAction: onUserAction,
    actionTypeProps: !isExpandedState && !isDisabledState && (stepDetails === null || stepDetails === void 0 ? void 0 : stepDetails.actionTypeProps),
    actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
    actionTypeOnPress: handleChangeButtonPress
  }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
    subHeading: subHeading
  }, {
    disabled: getIsDisabledState(isDisabledState, stepDetails === null || stepDetails === void 0 ? void 0 : stepDetails.disabled),
    subHeadingNumberOfLines: (stepDetails === null || stepDetails === void 0 ? void 0 : stepDetails.subHeadingNumberOfLines) || 1
  }, getTestId(testID, variant + "_LinkListItemWidget")));
};